import * as React from 'react';

import * as styles from './DropdownInner.css';

interface IDropdownInnerProps {
  dropdownMain: React.JSX.Element;
  dropdownBottom: React.JSX.Element;
}

export const DropdownInner: React.FC<IDropdownInnerProps> = ({ dropdownMain, dropdownBottom }) => {
  return (
    <div className={styles['dropdown']}>
      {dropdownMain}
      {dropdownBottom}
    </div>
  );
};
